import axios from "axios";
import { useEffect, useState } from "react";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("nf_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export function useBlobUrl(fileId) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    let u;
    api.get(`/files/${fileId}`, { responseType: "blob" })
      .then((r) => { u = URL.createObjectURL(r.data); setUrl(u); })
      .catch(() => setUrl(""));
    return () => { if (u) URL.revokeObjectURL(u); };
  }, [fileId]);
  return url;
}

export const waLink = (phone) => `https://wa.me/${(phone || "").replace(/\D/g, "")}`;
export const fmtDate = (s) => (s ? new Date(s).toLocaleString(localStorage.getItem("nf_lang") === "es" ? "es-NI" : "en-US") : "");
